// src/utils/is-browser.ts
var isBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var is_browser_default = isBrowser;

export { is_browser_default };
